(function() {
	"use strict";

	angular.module("swurveys.maker")
		.factory("paymentsConfigModal", Handler);

	function Handler(ModalService, swurveyAdminService, creditCardModal, confirmationModal, $filter, analyticsService, referralModal) {


		function show(user) {
			return ModalService.showModal({
				templateUrl: "app/modals/payments/swallet/swallet.html",
				controller: ["$element", "$scope", "close", function($element, $scope, close) {

					$scope.user = user;
					$scope.options = {
						creditsToPurchase : 250
					}

					$scope.swurveCreditOptions = {
						"100": 100,
						"250": 250,
						"500": 500,
						"1000": 1000,
						"5000": 5000,
						"10000": 10000,
						"25000": 25000
					};
					analyticsService.trackEvent('OpenSwallet');

					$scope.openReferralModal = function() {
						referralModal.show(user).then(function(modal) {
							modal.element.modal();
						});
					};

					$scope.dollarsPerCredit = function (creditsToPurchase) {
						var centsPerCredit = 11;
						if (creditsToPurchase >= 250)
							centsPerCredit = 10;
						if (creditsToPurchase >= 500)
							centsPerCredit = 9;
						if (creditsToPurchase >= 1000)
							centsPerCredit = 8;
						if (creditsToPurchase >= 5000)
							centsPerCredit = 7;
						if (creditsToPurchase >= 10000)
							centsPerCredit = 6;
						if (creditsToPurchase >= 25000)
							centsPerCredit = 5;
				        return centsPerCredit / 100;	
					}

					$scope.calculateCost = function (creditsToPurchase) {
						var costPerCredit = $scope.dollarsPerCredit(creditsToPurchase);
						return $filter("currency")(creditsToPurchase * costPerCredit, "$");
					};

					$scope.purchase = function(creditsToPurchase) {

						var balanceBeforePurchase = user.accountBalance;
						analyticsService.trackEvent('InitiateCheckout', creditsToPurchase);


						confirmationModal.show("Purchase",
							"You are about to purchase " + creditsToPurchase + " credits for " + $scope.calculateCost(creditsToPurchase) + ".",
							"Confirm Your Purchase",
							"Are you sure?").then(function(modal) {
							modal.element.modal();
							modal.close.then(function(confirm) {
								if (confirm === true) {
									resetLoaders();
									$scope.purchasing = true;
									swurveyAdminService.purchaseCredits(user.userId, creditsToPurchase, function(err, data) {
										$scope.$evalAsync(function() {
											$scope.purchasing = false;
											if (err) {
												$scope.error = err;
											}
											else {
												$scope.user.accountBalance = balanceBeforePurchase += creditsToPurchase;
												$scope.purchaseSuccessful = true;
												analyticsService.trackPurchase("Credits", creditsToPurchase, creditsToPurchase * $scope.dollarsPerCredit(creditsToPurchase));
											}
										});
									});
								}
							});
						});
					};

					var resetLoaders = function() {
						$scope.purchasing = false;
						$scope.addingCC = false;
						$scope.purchaseSuccessful = false;
						delete $scope.error;
					};

					$scope.close = function(confirm) {
						close(confirm, 500); // close modal and give boostrap time to animate
					};

					$scope.addCreditCard = function() {
						resetLoaders();
						$scope.addingCC = true;
						analyticsService.trackEvent('AssociateCreditCardMaybe');

                        console.log(user);
						creditCardModal.show(user.userId, function(err, data) {
							resetLoaders();
							if (err) {
								$scope.error = err;
							}
							else {
								$scope.addingCC = false;
								user.hasPaymentInstrument = true;
								analyticsService.trackEvent('AddPaymentInfo');
							}
						});
					};

					// Auto Topup code --------------------------------------------------

					$scope.enableAutoTopUp = isAutoTopUpEnabled();

					function isAutoTopUpEnabled() {
						return $scope.user.autoTopUpCreditAmount &&
							$scope.user.autoTopUpCreditThreshold &&
							$scope.user.autoTopUpCreditAmount > 0 &&
							$scope.user.autoTopUpCreditThreshold > 0;
					}

					$scope.toggleAutoTopUp = function(isEnabled) {
						if (isEnabled) {
							$scope.user.autoTopUpCreditAmount = 100;
							$scope.user.autoTopUpCreditThreshold = 100;
						}
						else {
							$scope.user.autoTopUpCreditAmount = 0;
							$scope.user.autoTopUpCreditThreshold = 0;
						}
					}

					$scope.$watchGroup(["user.autoTopUpCreditAmount", "user.autoTopUpCreditThreshold"], function(newVal, oldVal) {
						console.log(newVal, oldVal);
						if (oldVal == newVal) {
							//ignore the first update
							return;
						}
						resetLoaders();
						$scope.updatingPaymentOptions = true;
						$scope.updatingPaymentOptionsComplete = false;
						swurveyAdminService.updatePaymentOptions(user.userId, {
							autoTopUpCreditAmount: user.autoTopUpCreditAmount,
							autoTopUpCreditThreshold: user.autoTopUpCreditThreshold
						}, function(err, data) {
							if (err) {
								return $scope.error = err;
							}
							$scope.updatingPaymentOptions = false;
							$scope.updatingPaymentOptionsComplete = true;
						});
					});

				}]
			});
		}

		return {
			show: show
		};
	}
}());
